import React, { useState, useEffect } from "react";
import ReactModal from "react-modal";
import DropDown from "../DropDown";
import Input from "../Input";
import Button from "../Button";
import { loadShoppingLists } from "./Fetching";
import { post } from "../../lib/Fetching";
import styled from "styled-components";

const H2 = styled.h2`
  margin-top: 0px;
  margin-bottom: 10px;
  font-size: 14pt;
`;

const customStyles = {
  overlay: {
    zIndex: 999999999
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    borderRadius: 10,
    maxHeight: "90vh",
    border: 0,
    boxShadow: "0px 4px 12px 2px rgba(210,210,210,1)"
  }
};

export default function AddToShoppingList({
  company_id,
  branch_id,
  onClose,
  basketItems,
  onChange
}) {
  const [lists, setLists] = useState([]);
  const [name, setName] = useState("");
  const [shoppingList, setShoppingList] = useState(null);
  const [action, setAction] = useState("existing_list");
  const [registeredByItself, setRegisteredByItself] = useState(false);

  useEffect(() => {
    loadShoppingLists({ company_id, branch_id }).then(json => {
      setLists(json.shopping_lists);
    });
  }, []);

  const valid = () => {
    if (action === "existing_list" && shoppingList) return true;
    if (action === "new_list" && name) return true;
    return false;
  };

  const addToExistingList = () => {
    post("/products/shopping_lists/" + shoppingList + "/add_from_basket", {
      id: shoppingList,
      basket_data: basketItems
    })
      .then(onClose)
      .then(onChange);
  };

  const addToNewList = () => {
    post("/products/shopping_lists/create_from_basket", {
      name,
      company_id,
      branch_id,
      can_add_to_basket: !registeredByItself,
      basket_data: basketItems
    })
      .then(onClose)
      .then(onChange);
  };

  const performAction = () => {
    if (!valid()) return;
    if (action === "existing_list") {
      addToExistingList();
    } else {
      addToNewList();
    }
  };

  const changeExistingList = i => {
    setAction("existing_list");
    setShoppingList(i.value);
  };

  const changeName = e => {
    setAction("new_list");
    setName(e.target.value);
  };

  const options = lists.map(item => ({
    value: item.id,
    label: item.name + " (" + item.sample_count + " items)"
  }));

  return (
    <ReactModal
      isOpen={true}
      ariaHideApp={false}
      onRequestClose={onClose}
      style={customStyles}
    >
      <div
        style={{
          marginBottom: 20,
          borderBottomColor: "#DDDDDD",
          borderBottomStyle: "solid",
          borderBottomWidth: "1px",
          paddingBottom: 20,
          minWidth: 400
        }}
      >
        <H2>{I18n.t("add_items_to_list")}</H2>
        <p>
          {I18n.t("you_are_adding_items_from_the_trolley.counting", {
            count: basketItems.length
          })}
        </p>
        <label>
          <input
            type="radio"
            name="action"
            value="existing_list"
            checked={action === "existing_list"}
            onChange={() => setAction("existing_list")}
          />
          &nbsp; {I18n.t("add_to_existing_list")}
        </label>
        <DropDown
          options={options}
          value={shoppingList ? shoppingList.id : null}
          onChange={changeExistingList}
        />
      </div>
      <div style={{ marginBottom: 20 }}>
        <label>
          <input
            type="radio"
            name="action"
            value="new_list"
            checked={action === "new_list"}
            onChange={() => setAction("new_list")}
          />
          &nbsp; {I18n.t("create_a_new_list")}
        </label>
        <Input
          className="form-control"
          value={name}
          onChange={changeName}
          placeholder=""
          onFocus={() => setAction("new_list")}
        />
      </div>
      <div>
        <Button
          disabled={!valid()}
          title={I18n.t("save_and_continue")}
          onClick={performAction}
          primary
          style={{ marginRight: 20 }}
        />
        <Button title={I18n.t("cancel")} onClick={onClose} style={{ marginRight: 20 }} />
      </div>
    </ReactModal>
  );
}
